export enum FormField {
  PRESSURE_INJURY_PREVENTION_BRADEN_SCALE_COMPLETED = 'pressureInjuryPreventionBradenScaleCompleted',
  EXISTING_WOUNDS_PATIENT_HAS_EXISTING_WOUNDS = 'existingWoundsPatientHasExistingWounds',
  EXISTING_WOUNDS_LOCATIONS = 'existingWoundsLocations',
  WOUND_CARE_PLAN_WOUND_CARE_PLAN_COMPLETED = 'woundCarePlanWoundCarePlanCompleted'
}
